/**
 * @generated SignedSource<<1cf509940fe46ac59ae720a6b4a5fa1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreFormattedDate$data = {
  readonly storeFormattedDate: string;
  readonly " $fragmentType": "StoreFormattedDate";
};
export type StoreFormattedDate$key = {
  readonly " $data"?: StoreFormattedDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "DEFAULT",
      "kind": "LocalArgument",
      "name": "style"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreFormattedDate",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "style",
          "variableName": "style"
        }
      ],
      "kind": "ScalarField",
      "name": "storeFormattedDate",
      "storageKey": null
    }
  ],
  "type": "StoreZonedDate",
  "abstractKey": null
};

(node as any).hash = "a5520ff9c01d888d5572582895e9a819";

export default node;
